<template>
  <div id="mz-songs-list">
    <!-- <mb-presentation v-if="presentationState"></mb-presentation> -->
    <mb-info :left-pos="3.5" :background-style="'#0054a3'" v-if="info" :info="info"></mb-info>
    <div class="presentation-items">
      <p class="presentation-items-title">{{ title }}</p>
      <div class="presentation-items-scroll">
        <div class="presentation-items-not-full">
          <div
            :id="'presentation-item-' + i1"
            :key="'presentation-grid' + i1"
            v-for="(item, i1) in presentationKeys"
            class="presentation-item"
            :class="{ 'disable-presentation': showData(item) }"
            @click="pleaseShowMePresentation(item)"
          >
            <!-- <img :src="giveMeImagePlease('presentation/' + item + '/img.png')" /> -->
            <div class="tooltip">
              <p>
                <i>{{ returnTitle(item) }}</i>
              </p>
            </div>
            <p class="presentation-title" :id="'presentation-title-' + i1">
              <span :key="'i' + i2 + i2" v-for="(it, i2) in item">{{ it }}</span>
            </p>
          </div>
        </div>
      </div>
    </div>
    <svg @click="redirectMain" class="home-btn" viewBox="0 0 24 24" style="width: 2.5vw; width: 2.5vw">
      <path d="M12 3L2 12h3v8h6v-6h2v6h6v-8h3L12 3zm5 15h-2v-6H9v6H7v-7.81l5-4.5 5 4.5V18z" />
      <path class="center" d="M7 10.19V18h2v-6h6v6h2v-7.81l-5-4.5z" opacity=".3" />
      <path d="M0 0h24v24H0z" fill="none" />
    </svg>
    <!-- <dir @click="redirectMain" class="home-btn" v-if="isWeb || multiconfig">
      <img :src="homeIcon" alt="Home" />
    </dir> -->
    <img class="logo-box" src="./logoMAC_kolor.png" alt="Logo MAC S.A." />
  </div>
</template>
<script>
// import INFO from '../../config/info/utwory.js';
import _ from 'lodash';
import MbInfo from '../MbInfo/MbInfo.vue';
// import MbPresentation from '../MbPresentation/MbPresentation.vue';
export default {
  name: 'mz-songs-list',
  components: {
    MbInfo,
  },
  data: function () {
    return {
      info: null,
      presentationKeys: null,
      title: '',
    };
  },
  // beforeRouteEnter(to, from, next) {
  //   next();
  // },
  mounted() {
    this.init();
  },
  methods: {
    showData(key) {
      const multibookType = this.$store.getters.multibookType;
      let pres = this.$store.getters[`${_.upperFirst(multibookType)}/songs`];
      let data = pres.get(key);
      if (data.inactive) {
        return true;
      } else return false;
    },
    returnTitle(key) {
      const multibookType = this.$store.getters.multibookType;
      let pres = this.$store.getters[`${_.upperFirst(multibookType)}/songs`];
      let data = pres.get(key);
      if (data.name) {
        return data.name;
      } else return 'Karaoke';
    },
    redirectMain() {
      this.$router.push(`/`);
    },
    pleaseShowMePresentation(id) {
      if (this.showData(id)) {
      } else {
        const multibookType = this.$store.getters.multibookType;
        // this.$store.commit(
        //   'STATE_PRESENTATION_CONFIG',
        //   require(`__staticDir/${multibookType}/presentation/${id}/config.js`).default
        // );
        // this.$store.commit('STATE_PRESENTATION_SHOW', true);
        // if (this.$store.getters.getPresentationConfig) {
        this.$router.push('/game/by/id/' + id);
        // }
      }
    },
    giveMeImagePlease(path) {
      try {
        return require(`__staticDir/${this.$store.getters.multibookType}/${path}`);
      } catch (err) {
        console.log(err);
      }
    },
    init() {
      const multibookType = this.$store.getters.multibookType;
      console.log(this.$store.getters[`${_.upperFirst(multibookType)}/songs`]);
      const pres = this.$store.getters[`${_.upperFirst(multibookType)}/songs`];
      this.presentationKeys = pres.keys();
      this.title = pres.get(pres.keys().next().value).title || this.title;
      let c = multibookType.charAt(multibookType.length - 1),
        end = '';
      if (!isNaN(parseInt(c, 10))) {
        end = c;
      }
      try {
        this.info = require('../../config/info/utwory' + end + '.js').default;
      } catch {
        console.log('%cInfoUtwory - error', 'font-weight: bold; background: red; color: white; padding: 0px 10px');
      }
    },
  },
  computed: {
    homeIcon() {
      try {
        return require(`__mainSrcDir/assets/icons/book/headerBar/home-48px.svg`);
      } catch {
        console.log(
          '%cHomeIcon MzSongList- error',
          'font-weight: bold; background: red; color: white; padding: 0px 10px'
        );
      }
      return null;
    },
    presentationState() {
      return this.$store.getters.getPresentationState;
    },
    presentations() {
      const multibookType = this.$store.getters.multibookType;
      console.log(multibookType);
      return this.$store.getters[`${_.upperFirst(multibookType)}/presentations`];
    },
  },
};
</script>

<style lang="sass">
@import ~@/assets/sass/songsListVariable
@import ~@/assets/sass/variable
$break-large: 1400px
#mz-songs-list
  width: 100vw
  height: 100vh
  background: $songsListBackground
  overflow: hidden
  color: white
  h1
    color: white
  .presentation-items
    width: 100%
    height: calc(100%)
    text-align: center
    padding-top: 2vmin
    .presentation-items-title
      font-size: $songsListTitleFontSize
      color: $songsListTitleColor
    .presentation-items-scroll
      overflow-y: scroll
      max-height: calc(100% - 4rem - 2vmin)
      .presentation-items-not-full
        width: 80%
        margin-left: 10%
        .presentation-item
          box-shadow: .5vh .5vh 2vh 0vh rgba(0,0,0,.5)
          background: $songsListItemBackground
          width: 44%
          height: 5vmin
          display: inline-block
          text-align: center
          margin: .5vmin 3vmin
          position: relative
          transition: .5s
          cursor: pointer
          overflow: hidden
          // @media screen and (max-width: $break-large)
          //   width: 30vmax
          //   height: calc(30vmax * 0.5625)
          &:hover
            transform: scale(1.1)
          .tooltip
            width: 100%
            height: 100%
            display: flex
            align-items: center
            opacity: 1
            justify-content: center
            p
              color: $songsListItemTextColor
              margin: 0
              opacity: 1
              padding: 0
              text-align: center
              font-size: 1.2rem
          img
            width: 100%
            height: 100%
          .presentation-title
            max-height: 30%
            width: 100%
            position: absolute
            bottom: 0
            background: rgba(0,0,0,.5)
            margin: 0
            padding: 0
            opacity: 0
            transition: .5s
            p
              margin: 0
              padding: 0
.logo-box
  height: 10vw
  position: absolute
  bottom: 1vh
  right: 1vh
  opacity: 0
  display: flex
  justify-content: center

.presentation-items-scroll::-webkit-scrollbar-track
	-webkit-box-shadow: inset 0 0 6px rgba(0,0,0,0.3)
	background-color: $scrollbarBackground

.presentation-items-scroll::-webkit-scrollbar
	width: 10px
	background-color: $scrollbarBackground

.presentation-items-scroll::-webkit-scrollbar-thumb
	background-color: $scrollbarThumbBackground
	border: 2px solid $scrollbarThumbBackground

.grid-fade-leave-active, .grid-fade-enter-active
  transition: all .5s .5s linear

.grid-fade-leave-to, .grid-fade-enter
  transform: scale(0,0)
  opacity: 0
.home-btn
  position: absolute
  top: 0
  left: 0
  margin: 1rem !important
  padding-left: 0 !important
  padding-right: 0 !important
  transition: all 0.4s ease
  transform: scale(1) !important
  cursor: pointer
  fill: $homeIconColor
  .center
    fill: transparent
  img:hover
      cursor: pointer
      background: url('~@/assets/icons/book/headerBar/home-on48px.svg')
  &:hover
    transform: scale(1) !important
    .center
      fill: $homeIconColor

.disable-presentation
  filter: grayscale(1)
  background: gray !important
  &:hover
    transform: scale(1) !important
</style>
